var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import clsx from 'clsx';
export const Text = props => {
    const { align = 'leading', size = 'md', as, className, truncate, bold, color, children } = props, rest = __rest(props, ["align", "size", "as", "className", "truncate", "bold", "color", "children"]);
    const Component = as || 'span';
    return (React.createElement(Component, Object.assign({ className: clsx([
            align === 'leading' && 'text-start',
            align === 'center' && 'text-center',
            align === 'trailing' && 'text-end',
        ], [
            size === 'xs' && 'text-xs',
            size === 'sm' && 'text-sm',
            size === 'md' && 'text-base',
            size === 'lg' && 'text-lg',
            size === 'xl' && 'text-xl',
            size === '2xl' && 'text-2xl',
        ], truncate && 'truncate', bold && [
            bold === 'light' && 'font-medium',
            bold === 'medium' && 'font-semibold',
            bold === 'heavy' && 'font-bold',
        ], color && [
            color === 'default' && 'text-content-subdued',
            color === 'primary' && 'text-action-primary',
            color === 'positive' && 'text-content-on-positive',
            color === 'negative' && 'text-content-on-negative',
            color === 'attention' && 'text-content-on-attention',
            color === 'highlight' && 'text-content-on-highlight',
        ], className) }, rest), children));
};
//# sourceMappingURL=Text.js.map